import { ListItem } from '../models/ListItem';
import { Vendor } from '../models/vendor.model';
import GenericService from './genericService';

class VendorService extends GenericService<Vendor, ListItem> {
  constructor() {
    super('/api/Vendor');
  }
}

export const vendorService = new VendorService();